import { LocalStorage } from 'shared/helpers/localStorage';
import { LOCAL_STORAGE_KEYS } from 'dashboard/constants/localStorage';
import { normalizeInterfaceTheme } from 'shared/helpers/chatBackground';

const CUSTOM_INTERFACE_THEMES = new Set(['mist', 'warm', 'sky', 'mint']);

const setDocumentColorScheme = (colorScheme, isOSOnDarkMode) => {
  const useDarkMode =
    colorScheme === 'dark' || (colorScheme === 'auto' && isOSOnDarkMode);

  document.body.classList.toggle('dark', useDarkMode);
  document.documentElement.style.setProperty(
    'color-scheme',
    useDarkMode ? 'dark' : 'light'
  );
};

export const setColorTheme = isOSOnDarkMode => {
  const interfaceTheme = normalizeInterfaceTheme(
    LocalStorage.get(LOCAL_STORAGE_KEYS.INTERFACE_THEME)
  );

  if (CUSTOM_INTERFACE_THEMES.has(interfaceTheme)) {
    document.body.classList.remove('dark');
    document.body.dataset.interfaceTheme = interfaceTheme;
    document.documentElement.style.setProperty('color-scheme', 'light');
    return;
  }

  delete document.body.dataset.interfaceTheme;
  const selectedColorScheme =
    LocalStorage.get(LOCAL_STORAGE_KEYS.COLOR_SCHEME) || 'auto';
  setDocumentColorScheme(selectedColorScheme, isOSOnDarkMode);
};

export const applyInterfaceTheme = (
  theme,
  isOSOnDarkMode = window.matchMedia('(prefers-color-scheme: dark)').matches
) => {
  const interfaceTheme = normalizeInterfaceTheme(theme);
  const colorScheme = interfaceTheme === 'system' ? 'auto' : interfaceTheme;

  LocalStorage.set(LOCAL_STORAGE_KEYS.INTERFACE_THEME, interfaceTheme);
  if (!CUSTOM_INTERFACE_THEMES.has(interfaceTheme)) {
    LocalStorage.set(LOCAL_STORAGE_KEYS.COLOR_SCHEME, colorScheme);
  }
  setColorTheme(isOSOnDarkMode);
};
